import { EFileSubmissionDisplayStatus, IEFileDisplayStatus } from "projects/lib_util/src/public-api";

export class EFileStatusPill{
    eFileStatus: IEFileDisplayStatus;
    isSubmissionStatus: boolean;
    isVisible: boolean;
    total: number = 0;
  
    constructor(eFileStatus: IEFileDisplayStatus, isVisible: boolean = true) {
      this.eFileStatus =  eFileStatus;
      this.isSubmissionStatus = eFileStatus instanceof EFileSubmissionDisplayStatus;
      this.isVisible = isVisible;
    }
  }